import { render, staticRenderFns } from "./instockDetail.vue?vue&type=template&id=668fd98b&scoped=true&"
import script from "./instockDetail.vue?vue&type=script&lang=js&"
export * from "./instockDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "668fd98b",
  null
  
)

export default component.exports